<template>
    <div class="amic_container lp_container"> 
		<SliderBuyOnline/>
        <mid v-for="(component, index) in pageContentData.sections" :key="'key' + index + uid()" :component_data="component" ></mid>
    </div>
</template>

<script>
require("@/assets/overrides.css");
require("@/assets/utilities.css");

import Vue from "vue";
import midComponent from "@/components/Transfer/generic.vue";
import PortalVue from "portal-vue";
import VueScrollmagic from "vue-scrollmagic";
import SliderBuyOnline from "@/components/SliderBuyOnline2020/SliderBuyOnlineMain";
import "swiper/css/swiper.css";

Vue.component("mid", midComponent);
Vue.use(PortalVue);
Vue.use(VueScrollmagic);

const mixins = {
  computed: {
    pl() {
      return window.pageContentData.locale === 'pl';
    }
  },
  methods: {
    componentify(data, defaultComp = "contents", passAlong = {}) {
      if (typeof data.component === "undefined") {
        data.component = defaultComp;
      }
      if (passAlong) {
        Object.assign(data, passAlong);
      }
      return data;
    },
    texts(obj) {
      let texts = [];
      Object.keys(obj).forEach((key) => {
        if (key.indexOf("text") !== -1) {
          texts.push(obj[key]);
        }
      });
      return texts;
    },
  },
};
Vue.mixin(mixins);

export default {
  data() {
    return {
      pageContentData: window.pageContentData,
    };
  },
  components: {
    SliderBuyOnline,
  },
  methods: {
    uid() {
      let x = this.cid++;
      return x;
    },
  },
  created() {
    this.cid = 0;
  },
};
</script>


<style>
</style>
